// extracted by mini-css-extract-plugin
module.exports = {"container":"Hgx8_dfy","header":"yEySqWzP","title":"__2GXF4Uet","content":"YVxnynx_","singleSearchWordCard":"xKEsDnHb","searchWordImage":"NuHNT1_4","searchWord":"rmnfIe_H"};